const { UI_ADDRESS_FIELDS } = require('../enums');
const { PROMPT_NAMES, PROMPT_GROUP_NAMES } = require('../prompts/names');

/**
 * Get the coverage type(s), as an upper-cased string array.
 *
 * @param {{}} uiData
 * @returns {Array<string>} An array of coverage type(s), e.g. [HOME, AUTO], or an empty array.
 */
function getCoverageTypes(uiData = {}) {
  const coverageType = uiData[PROMPT_NAMES.COVERAGE_TYPE];
  if (!coverageType) return [];
  if (!Array.isArray(coverageType)) return [coverageType.toUpperCase()];
  return coverageType.map(cov => cov.toUpperCase());
}

/**
 * Check if an array includes any of the coverageTypes.
 *
 * @param {Array<string>} covTypesArray1 An array of coverage types.
 * @param {Array<string>} covTypesArray2 Another array of coverageTypes.
 * @returns {boolean}
 */
function includesCoverageType(covTypesArray1, covTypesArray2) {
  return covTypesArray1.some(cov => covTypesArray2.includes(cov));
}

/**
 * Get the composite field from the address, falling back to the legacy string value.
 *
 * @param {object|string} address
 * @returns {string|null} The address composite.
 */
function getAddressComposite(address) {
  if (address && address[UI_ADDRESS_FIELDS.COMPOSITE]) return address[UI_ADDRESS_FIELDS.COMPOSITE];
  if (typeof address === 'string') return address;
  return null;
}

/**
 * Get Primary Driver, always the first driver in the drivers array
 *
 * @param {{}} uiData
 * @returns {{}} A uiData driver object
 */
function getPrimaryDriver(uiData) {
  const drivers = uiData[PROMPT_GROUP_NAMES.DRIVERS] || [];
  return drivers[0];
}

/**
 *
 * @param {{}} uiData
 * @returns {string} Primary applicant's first name
 */
function getPrimaryFirstName(uiData) {
  const primaryDriver = getPrimaryDriver(uiData) || {};
  return uiData[PROMPT_NAMES.FIRST_NAME] || primaryDriver[PROMPT_NAMES.FIRST_NAME];
}

/**
 *
 * @param {{}} uiData
 * @returns {string} Primary applicant's last name
 */
function getPrimaryLastName(uiData) {
  const primaryDriver = getPrimaryDriver(uiData) || {};
  return uiData[PROMPT_NAMES.LAST_NAME] || primaryDriver[PROMPT_NAMES.LAST_NAME];
}

module.exports = {
  getAddressComposite,
  getCoverageTypes,
  getPrimaryDriver,
  includesCoverageType,
  getPrimaryFirstName,
  getPrimaryLastName
};
